import { render, staticRenderFns } from "./order_settlement_detail.vue?vue&type=template&id=b2ec3eb8&scoped=true"
import script from "./order_settlement_detail.vue?vue&type=script&lang=js"
export * from "./order_settlement_detail.vue?vue&type=script&lang=js"
import style0 from "./order_settlement_detail.vue?vue&type=style&index=0&id=b2ec3eb8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2ec3eb8",
  null
  
)

export default component.exports